/**
 * DevExtreme (esm/__internal/grids/grid_core/sticky_columns/const.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const STICKY_BORDER_WIDTH = 2;
export var StickyPosition;
!function (StickyPosition) {
  StickyPosition.Left = "left";
  StickyPosition.Right = "right";
  StickyPosition.Sticky = "sticky";
}(StickyPosition || (StickyPosition = {}));
export const CLASSES = {
  stickyColumn: "sticky-column",
  stickyColumnLeft: "sticky-column-left",
  stickyColumnRight: "sticky-column-right",
  stickyColumnBorderRight: "sticky-column-border-right",
  stickyColumnBorderLeft: "sticky-column-border-left",
  stickyColumns: "sticky-columns",
  firstHeader: "first-header",
  columnNoBorder: "column-no-border",
  groupRowContainer: "group-row-container",
  focusedFixedElement: "dx-focused-fixed-element",
  focused: "dx-focused",
  hidden: "dx-hidden"
};